module.exports = __webpack_public_path__ + "static/img/banner1.3172265.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/shareFiesta/banner1.webp
// module id = Dzc5
// module chunks = 0